import React, { useState } from "react";
import { Button } from "@mui/material";
import "./TopBar.scss";
import PerformanceModal from "../PerformanceModal/PerformanceModal";
import SearchCoin from "../SearchCoin/SearchCoin";

export default function TopBar({
  onFilterClick,
  // onPublishClick,
  activeFiltersCount,
  onExportClick,
  exporting,
  onSearchSelect,
  onSearchClear,
}) {

  const [openPerformance, setOpenPerformance] = useState(false);

  return (
    <>
      <div className="top-bar">
        <div className="search-wrapper">
          <SearchCoin onSelect={onSearchSelect} onClear={onSearchClear} />
        </div>

        <div className="topbar-buttons">

          <Button
            variant="contained"
            onClick={() => setOpenPerformance(true)}
          >
            Performance
          </Button>

          <Button
            variant="outlined"
            onClick={onExportClick}
            disabled={exporting}
          >
            {exporting ? 'Exporting...' : 'Export'}
          </Button>

          {/* <Button
            variant="contained"
            onClick={onPublishClick}
          >
            + Publish
          </Button> */}

        </div>

      </div>

      <PerformanceModal
        open={openPerformance}
        onClose={() => setOpenPerformance(false)}
      />
    </>
  );
}